import type { LinkingMatrix } from '../types';

export const MATRIX: LinkingMatrix = {
    positions: ['trade-pro'],
    results: [],
    watchlist: [],
    'order-blotter': [],
    'trade-pro': [],
    'trade-pro-multi': [],
    'basket-trading': [],
    'manual-review': [],
    messages: [],
    executions: [],
    accounts: [],
    orders: [],
    lab: [],
    table: [],
    'alpha-lens': [],
    searchalpha: [],
    scanner: [],
    screener: [],
    news: [],
    events: [],
    filings: [],
    notepad: [],
    'alpha-eye': [],
    platforms: [],
    symbols: [],
    traders: [],
    alerts: [],
    backtest: [],
    'tradingview-chart': [],
};
